module.exports = __webpack_public_path__ + "c4a85cb92c5fbffc43c17934f2f65a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescenceScale/none@2x.png
// module id = 863
// module chunks = 0